import React, { useId } from 'react';
// import icon from '../assets/icons/copy.svg';
import { FaCopy } from 'react-icons/fa6';
import { Tooltip } from 'react-tooltip';

function CopyButton({ className, content, 'aria-label': ariaLabel }) {
  const tooltipId = useId();
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
    //   alert("Content copied to clipboard!");
    } catch (error) {
      console.error("Failed to copy: ", error);
    }
  };

  return (
    <>
      <button 
        type="button"
        className={`${className} rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500`}
        onClick={handleCopy}
        data-tooltip-id={tooltipId}
        data-tooltip-content="Copy to clipboard"
        aria-label={ariaLabel}
      >
        {/* <img src={icon} alt="icon" width="24" height="24" /> */}
        <FaCopy size={20} color="#68C7CC" />
      </button>
      <Tooltip id={tooltipId} place="top" effect="solid" positionStrategy="fixed" />
    </>
  );
}

export default CopyButton;
